Vue.component('packs', {
  template: templates.packs,
  data() {
    return {
      model: {
        edit: false,
        pack: {
          id: null,
          name: null,
          size: 0,
          ultraChance: 0,
          legendaryChance: 0,
          ultimateChance: 0,
          boneCardChance: 0,
          ascChance: 0,
          deltaChance: 0,
          variantChance: 0,
          ultraGuaranteed: false,
          legendaryGuaranteed: false,
          boneCardGuaranteed: false,
          deltaGuaranteed: false,
          variantGuaranteed: false,
          limit: 0,
          active: false,
          chest_active: false,
          streamerShow: false,
          card_amount: 0,
          xp: 0,
          givePack: [{ packId: null, packs_quantity: 0 }],
          randomCard: [{ randomCard: 0, random_amount: 0 }],
          rewardFrames: [],
          rewardFrameMode: 'single-frame',
          rewardCardBacks: [],
          random_amount: 0,
          barks: 0,
          selectedMode: null,
          packs_amount: null,
          images: {}
        },
        cards: {},
        packs: {},
        randomcard: [
          {
            name: ''
          },
          {
            name: 'Standard Card'
          },
          {
            name: 'Ultra Card'
          },
          {
            name: 'Legendary Card'
          },
          {
            name: 'Ultimate Card'
          },
          {
            name: 'Bone Card'
          },
          {
            name: 'Ascension Card'
          },
          {
            name: 'Delta Card'
          },
          {
            name: 'Variant Card'
          }
        ],
        frames: {},
        backgrounds: {},
        cardBacks: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.getFrames();
    c.getBackgrounds();
    c.getCardBacks();
    c.connect();
    c.$root.$on('remove-existing-image', data => {

      c.removeCurrentFile(data);
    })
  },
  methods: {
    connect() {
      const c = this;
      c.ws = new WebSocket(utils.getWsUrl('', 9443));

      c.ws.onmessage = (event) => {

        const messageData = event.data;

          
          // if(parsedData.channelId === utils.cookies.get('channelId') && parsedData.){
       

      
      };

      c.ws.onopen = () => {
        console.log('WebSocket connection established');
      };

      c.ws.onclose = () => {
        console.log('WebSocket connection closed');
      };
    },
    get() {
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
          c.$root.$emit('getPacks', data);
          c.$root.$emit('unlockPacks', data);
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    edit(id) {

      const c = this;

      let data = c.model.packs[`${id}`];

      if (id == c.model.pack.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.pack = {
        id: id,
        name: data.name,
        size: data.size,
        limit: data.limit,
        ultraChance: data.ultraChance,
        legendaryChance: data.legendaryChance,
        ultimateChance: data.ultimateChance,
        ultraGuaranteed: data.ultraGuaranteed,
        legendaryGuaranteed: data.legendaryGuaranteed,
        boneCardGuaranteed: data.boneCardGuaranteed,
        deltaGuaranteed: data.deltaGuaranteed || false,
        variantGuaranteed: data.variantGuaranteed || false,
        boneCardChance: data.boneCardChance,
        ascChance: data.ascChance,
        deltaChance: data.deltaChance || 0,
        variantChance: data.variantChance || 0,
        active: data.active,
        chest_active: data.isChest,
        streamerShow: data.streamerShow,
        xp: data.rewards.xp,
        givePack: data.packs.length === 0 ? [{ packId: null, packs_quantity: 0 }] : data.packs,
        randomCard: data.otherReward.length === 0 ?  otherReward = [{ randomCard: 0, random_amount: 0 }] : data.otherReward,
        rewardFrames: data.rewards.rewardFrames || [],
        rewardFrameMode: data.rewards.rewardFrameMode || 'single-frame',
        rewardCardBacks: data.rewards.rewardCardBacks || [],
        random_amount: data.otherReward.length === 0 ? 0 : data.otherReward.length,
        barks: data.rewards.barks,
        selectedMode: data.selectedMode,
        packs_amount: data.packs.length === 0 ? 0 : data.packs.length,
        images: data.images || {},
      }

      // Load linked reward frames/backgrounds from adminRewardFrames (for chests only)
      if (data.isChest) {
        c.loadChestRewardFrames(id);  // Pass the chest ID, not the name
      }

    },
    add() {
      const c = this;
      c.model.edit = true;
    },
    save() {
      const c = this;

      const data = c.model.pack;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (data.active && data.size == 0) {
        utils.alert.error('The pack must have at least one card to be activated.');
        return;
      }
      packService.save(data)
        .then(function (response) {
          const packId = response.data?.id || data.id;

          // Save reward frames/backgrounds if chest is active and has selections
          if (data.chest_active && data.rewardFrames && data.rewardFrames.length > 0) {
            c.saveChestRewardFrames(packId, data.rewardFrames);
          }

          // rewardCardBacks are saved via pack/save.php directly (included in POST body)

          // if (data.id) {
          //   c.model.packs[`${data.id}`] = data;
          // } else {
          //   data.id = response.data.id;
          //   c.model.packs[`${data.id}`] = data;
          // }

          c.reset();
          c.get();

          const wsData = {
            message: 'pack_given',
            pack_update: true,
          }
          c.ws.send(JSON.stringify(wsData));

        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    reset() {
      const c = this;
      c.model.edit = false;
      
      c.model.pack = {
        id: null,
        name: null,
        size: null,
        limit: 0,
        ultraChance: 0,
        legendaryChance: 0,
        ultimateChance: 0,    
        boneCardChance: 0,
        ascChance: 0,
        deltaChance: 0,
        variantChance: 0,
        ultraGuaranteed: false,
        legendaryGuaranteed: false,
        boneCardGuaranteed: false,
        deltaGuaranteed: false,
        variantGuaranteed: false,
        active: false,
        chest_active: false,
        streamerShow: false,
        card_amount: 0,
        xp: 0,
        wins: 0,
        givePack: [{ packId: null, packs_quantity: 0 }],
        randomCard: [{ randomCard: null, random_amount: 0 }],
        rewardFrames: [],
        rewardFrameMode: 'single-frame',
        rewardCardBacks: [],
        random_amount: 0,
        barks: 0,
        selectedMode: null,
        packs_amount: 0,
        images: {}
      }
    },
    incrementPack(){
      const c = this;
      c.model.pack.packs_amount++
      c.model.pack.givePack.push({ packId: null, packs_quantity: 0 });
    },
    incrementCards(){
      const c = this;
      c.model.pack.card_amount++
      c.model.pack.cards.push({ cardId: null, tier: 0 });
    },
    incrementRandomCards(){
      const c = this;
      c.model.pack.random_amount++
      c.model.pack.randomCard.push({ randomCard: 0, random_amount: 0 });
    },
    removePack(index) {
      if (this.model.pack.packs_amount > 0) {
        this.model.pack.packs_amount--;
        this.model.pack.givePack.splice(index, 1);
      }
    },
    removeCard(index){
      if (this.model.pack.card_amount > 0) {
        this.model.pack.card_amount--;
        this.model.pack.cards.splice(index, 1);
      }
    },
    removeRandomCard(index){
      if (this.model.pack.random_amount > 0) {
        this.model.pack.random_amount--;
        this.model.pack.randomCard.splice(index, 1);
      }
    },
    getPack(){
      const c = this;
      let data = {};

      packService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.packs = data;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    chestIsActive(){
      const c =this;

      if(!c.model.pack.chest_active){
        c.model.pack = {
          xp: 0,
          wins: 0,
          givePack: [{ packId: null, packs_quantity: 0 }],
          randomCard: [{ randomCard: null, random_amount: 0 }],
          rewardFrames: [],
          rewardFrameMode: 'single-frame',
          rewardCardBacks: [],
          random_amount: 0,
          barks: 0,
          selectedMode: null,
          packs_amount: 0
        }
      }
    },
    getFrames(){
      const c = this;
      let data = {};

      frameService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.frameImage = d.uploaded && d.extension
              ? `${root}/images/frames/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
              : null;
            data[`${d.id}`] = d;
          }
          c.model.frames = data;
        })
        .catch(function (error) {
          console.error('Error loading frames:', error);
        });
    },
    getBackgrounds(){
      const c = this;
      let data = {};

      backgroundService.get()
        .then(function (response) {
          for (let d of response.data) {
            d.backgroundImage = d.extension
              ? `${root}/images/backgrounds/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
              : null;
            data[`${d.id}`] = d;
          }
          c.model.backgrounds = data;
        })
        .catch(function (error) {
          console.error('Error loading backgrounds:', error);
        });
    },

    getCardBacks(){
      const c = this;
      let data = {};

      cardBackService.get()
        .then(function (response) {
          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.cardBacks = data;
        })
        .catch(function (error) {
          console.error('Error loading card backs:', error);
        });
    },

    loadChestRewardFrames(chestType){
      const c = this;

      // Load all reward frames for chest type, then filter by chest_type
      rewardFrameService.get({ reward_type: 'chest' })
        .then(function (response) {
          if (!response.success) {
            console.error('Failed to load reward frames');
            return;
          }

          // Filter frames linked to this specific chest type
          const linkedFrames = (response.data || []).filter(r => r.chest_type == chestType);
          const frameRewards = linkedFrames.map(r => ({ id: r.frame_id, type: 'frame' }));

          // Load all reward backgrounds for chest type
          return rewardBackgroundService.get({ reward_type: 'chest' })
            .then(function (bgResponse) {
              if (!bgResponse.success) {
                console.error('Failed to load reward backgrounds');
                return;
              }

              // Filter backgrounds linked to this specific chest type
              const linkedBackgrounds = (bgResponse.data || []).filter(r => r.chest_type == chestType);
              const backgroundRewards = linkedBackgrounds.map(r => ({ id: r.background_id, type: 'background' }));

              // Combine both and update the pack rewards
              const combinedRewards = [...frameRewards, ...backgroundRewards];

              if (combinedRewards.length > 0) {
                // Determine mode based on count and types
                let mode = 'single-frame';
                if (combinedRewards.length === 1) {
                  mode = combinedRewards[0].type === 'frame' ? 'single-frame' : 'single-background';
                } else {
                  mode = 'multiple';
                }

                // Update pack properties directly with Vue.set for reactivity
                Vue.set(c.model.pack, 'rewardFrames', combinedRewards);
                Vue.set(c.model.pack, 'rewardFrameMode', mode);
              } else {
                console.log('No linked frames/backgrounds found for chest');
              }
            });
        })
        .catch(function (error) {
          console.error('Error loading chest reward frames/backgrounds:', error);
        });
    },

    saveChestRewardFrames(chestId, rewardFrames){
      console.log('Saving reward frames for chest:', chestId, rewardFrames);

      // First, load existing frames/backgrounds to delete them
      Promise.all([
        rewardFrameService.get({ reward_type: 'chest' }),
        rewardBackgroundService.get({ reward_type: 'chest' })
      ]).then(function([frameResponse, bgResponse]) {
        console.log('Fetched existing frames:', frameResponse);
        console.log('Fetched existing backgrounds:', bgResponse);

        // Find existing frames/backgrounds for this chest
        const existingFrames = (frameResponse.data || []).filter(r => r.chest_type == chestId);
        const existingBackgrounds = (bgResponse.data || []).filter(r => r.chest_type == chestId);

        console.log('Existing frames for this chest:', existingFrames);
        console.log('Existing backgrounds for this chest:', existingBackgrounds);

        // Delete existing frames
        const deletePromises = [];
        existingFrames.forEach(frame => {
          console.log('Deleting chest frame:', frame.id);
          deletePromises.push(
            rewardFrameService.delete(frame.id)
              .then(res => console.log('Deleted chest frame:', frame.id, res))
              .catch(err => console.error('Error deleting chest frame:', frame.id, err))
          );
        });
        existingBackgrounds.forEach(bg => {
          console.log('Deleting chest background:', bg.id);
          deletePromises.push(
            rewardBackgroundService.delete(bg.id)
              .then(res => console.log('Deleted chest background:', bg.id, res))
              .catch(err => console.error('Error deleting chest background:', bg.id, err))
          );
        });

        return Promise.all(deletePromises);
      }).then(function() {
        // Separate frames and backgrounds
        const frames = rewardFrames.filter(r => r.type === 'frame');
        const backgrounds = rewardFrames.filter(r => r.type === 'background');

        // Save each frame
        const savePromises = [];
        frames.forEach(frame => {
          const frameData = {
            frame_id: frame.id,
            chest_type: chestId,
            reward_type: 'chest',
            unlock_type: 'frame',
            is_active: true,
            is_guaranteed: true
          };

          savePromises.push(
            rewardFrameService.save(frameData)
              .then(function(response) {
                console.log('Saved chest reward frame:', response);
              })
              .catch(function(error) {
                console.error('Error saving chest reward frame:', error);
              })
          );
        });

        // Save each background
        backgrounds.forEach(background => {
          const backgroundData = {
            background_id: background.id,
            chest_type: chestId,
            reward_type: 'chest',
            is_active: true,
            is_guaranteed: true
          };

          savePromises.push(
            rewardBackgroundService.save(backgroundData)
              .then(function(response) {
                console.log('Saved chest reward background:', response);
              })
              .catch(function(error) {
                console.error('Error saving chest reward background:', error);
              })
          );
        });

        return Promise.all(savePromises);
      }).then(function() {
        console.log('All chest reward frames/backgrounds saved successfully');
      }).catch(function(error) {
        console.error('Error in saveChestRewardFrames:', error);
      });
    },

    handleMediaUpload(data){
      const c = this;
      if (!c.model.pack.images) {
        c.model.pack.images = {};
      }
      const currentKeys = Object.keys(c.model.pack.images);

      // Determine the next key (numeric)
      const nextKey = currentKeys.length > 0 ? Math.max(...currentKeys.map(Number)) + 1 : 0;

      // Add the new image
      for(i=0;i<data.files.length;i++){
        c.model.pack.images[nextKey + i] = data.files[i].filename;
      }
      
      // Refresh the pack list to show the updated image
      c.get();
      c.reset();
    },
    getPacksUrl(){
      const c = this;

      let id = c.model.pack.id;
      // Use different folder for chest vs regular packs
      // Chests use subdirectories, packs upload directly to folder
      const folder = c.model.pack.chest_active ? 'chest' : 'packs';
      const url = c.model.pack.chest_active
        ? `${root}/images/${folder}/${id}/`
        : `${root}/images/${folder}/`;
      return url;

    },
    removeCurrentFile(data){
      const c = this;

      const id = c.model.pack.id;
      // Use different folder for chest vs regular packs
      const uploadType = c.model.pack.chest_active ? 'chest' : 'packs';
      uploadService.deleteFile(uploadType, id, data.image)
      .then(function (response) {

        console.log(response.data.id)
        Vue.delete(c.model.pack.images, data.index)
        utils.alert.success('File Removed!');
      })
      .catch(function (error) {
        utils.alert.error(error);
      });
    },
    getPackImageUrl(pack) {
      const c = this;
      if (!pack.images || Object.keys(pack.images).length === 0) {
        return '';
      }
      const firstImageKey = Object.keys(pack.images)[0];
      const imageFilename = pack.images[firstImageKey];
      const folder = pack.isChest ? 'chest' : 'packs';
      const url = pack.isChest
        ? `${root}/images/${folder}/${pack.id}/${imageFilename}`
        : `${root}/images/${folder}/${imageFilename}`;
      return url;
    },
    getPackImages(pack) {
      if (!pack.images || Object.keys(pack.images).length === 0) {
        return [];
      }

      if (pack.isChest) {
        // For chests, images are 1.png, 2.png, 3.png in the chest folder
        const imageCount = Math.min(Object.keys(pack.images).length, 3);
        const images = [];
        for (let i = 1; i <= imageCount; i++) {
          images.push(`${root}/images/chest/${pack.id}/${i}.png`);
        }
        return images;
      } else {
        // For regular packs, use the image filenames
        const imageKeys = Object.keys(pack.images).slice(0, 3);
        return imageKeys.map(key => {
          const imageFilename = pack.images[key];
          return `${root}/images/packs/${imageFilename}`;
        });
      }
    }
  }
});